export const SEPARATOR_BASE_CLASSES = "shrink-0 bg-border";
export const SEPARATOR_HORIZONTAL_CLASSES = "h-[1px] w-full";
export const SEPARATOR_VERTICAL_CLASSES = "h-full w-[1px]";

export const DEFAULT_ORIENTATION = "horizontal" as const;
export const DEFAULT_DECORATIVE = true; 